import React, { useState } from 'react';
import { Flex, Tabs, Tab, TabList, TabPanels, TabPanel, Icon, Text } from '@chakra-ui/react';

export default function TabsComponent({ tabs }) {
  const [tabIndex, setTabIndex] = useState(0);

  if (tabs.length === 0) {
    return null;
  }
  if (tabs.length === 1) {
    const { RenderComponent, props } = tabs[0];
    return <RenderComponent {...props} />;
  }

  return (
    <Tabs variant="unstyled" align="center" tabIndex={tabIndex} onChange={setTabIndex}>
      <TabList gap={5} display="grid" gridTemplateColumns="repeat(6, 1fr)">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            p={2}
            _selected={{ borderColor: 'primary.500' }}
            borderRadius={{ base: 0, md: '10px' }}
            borderColor="primary.50"
            borderBottomWidth="1px"
            borderTopWidth={{ base: 0, md: '1px' }}
            borderRightWidth={{ base: 0, md: '1px' }}
            borderLeftWidth={{ base: 0, md: '1px' }}
          >
            <Flex alignItems="center" gap={2}>
              <Icon
                as={tab.icon}
                fill="none"
                stroke="black"
                w={5}
                h={5}
                display={{ base: 'none', md: 'inline-block' }}
              />
              <Text variant={{ base: 'body-reg-lg', md: 'sub-head-med' }}>{tab.name}</Text>
            </Flex>
          </Tab>
        ))}
      </TabList>

      <TabPanels mt={8}>
        {tabs.map((tab, index) => (
          <TabPanel p={0} key={index}>
            <tab.RenderComponent {...tab.props} />
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
}
